import { Box, Grid, Paper, Typography } from '@mui/material';
import {
  AppFormikSelect,
  AppFormikTextField,
} from 'shared/components/AppComponents';
import { ReactComponent as Plus } from 'assets/images/plus_role_not.svg';
import { ReactComponent as PlusFill } from 'assets/images/plus_role.svg';
import { useFormikContext } from 'formik';
import { ROLES } from 'shared/Constants';
import { useEffect, useRef } from 'react';

interface AchievementFormProps {
  test: any;
}

const AchievementForm: React.FC<AchievementFormProps> = () => {
  const roleRef = useRef<HTMLDivElement | null>(null);
  const { values, setFieldValue, errors, submitCount } =
    useFormikContext<any>();

  const dynamicItems = [
    ...ROLES,
    ...(values.role ?? []).filter((r: any) => !ROLES.includes(r)),
  ];

  const handleAddCustomRole = (): void => {
    const custom = values.customtype?.trim();
    if (!custom) return;

    const existing: string[] = values.role ?? [];

    if (!existing.includes(custom)) {
      setFieldValue('role', [...existing, custom]);
    }

    setFieldValue('customtype', '');
  };

  useEffect(() => {
    if (submitCount === 0) return;
    if (!errors || Object.keys(errors).length === 0) return;

    if (Object.keys(errors || {}).includes('role')) {
      roleRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [errors, submitCount]);

  return (
    <Paper
      variant="outlined"
      className="achievement-form-wrapper"
      ref={roleRef}
    >
      <Typography variant="h6">Target roles *</Typography>
      <Grid container className="achievement-target-grid">
        <Grid item className="achievement-select" md={4}>
          <AppFormikSelect
            name="role"
            className="rework-selection"
            notched={false}
            labelId="fix-selection-label"
            testid="solicitor-dropdown"
            MenuProps={{ className: 'menu-fix-selection single-fix-rework' }}
            outerLabel={false}
            placeholder="Select Role"
            notEmphasized
            notSelectablePlaceholder
            multiple
            items={dynamicItems}
          />
        </Grid>
        <Grid item className="achievement-select" md={7}>
          <AppFormikTextField
            name="customtype"
            placeholder="Or type custom role"
            outerLabel={false}
          />
        </Grid>
        <Grid item className="achievement-select" md={1}>
          <Box
            onClick={handleAddCustomRole}
            sx={{ cursor: values.customtype ? 'pointer' : '' }}
          >
            {values.customtype ? <PlusFill /> : <Plus />}
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AchievementForm;
